import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AIManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        AI Motor Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>AI motor yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default AIManagement;
